import { ModalDefinition } from './../../../services/overlay.service';
import { Component, ViewChild, TemplateRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';

import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'templates-list',
	templateUrl: './templates-list.component.html',
	styleUrls: ['./templates-list.component.scss'],
	providers: [BbTableService]
})

export class TemplatesListComponent extends AbstractListComponent implements OnInit, OnDestroy {
	@ViewChild('createAppTemplate', { static: true }) createAppTemplate: TemplateRef<any>;

	subscriptions = new Subscription();
	cloningRight: boolean;
	putRight: boolean;
	filterConfig: BbFilterConfiguration;
	entitiesToClone: any[];
	appModal: ModalDefinition;

	constructor(protected bbTableService: BbTableService) {

		super(bbTableService);

		this.listConfiguration = {
			name: 'app',
			basePath: '/library/templates',
			activePath: '/library/templates',
			entityTranslation: this.translate.instant('APP').toLowerCase(),
			entitiesTranslation: this.translate.instant('APPS').toLowerCase()
		};

		this.filterConfig = {
			search: true,
			filters: [],
		};
	}

	ngOnInit() {
		this.bbTableService
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();

		this.subscriptions.add(this.authenticationService.hasPermission('cloning').subscribe(hasRight => {
			this.cloningRight = hasRight;
			if (hasRight) {
				this.bbTableService.setSelect(BbTableSelectOption.multi);
			}
		}));

		this.subscriptions.add(this.authenticationService.hasPermission('put').subscribe(putRight => {
			this.putRight = putRight;
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
		super.ngOnDestroy();
	}

	openCreateTemplateModal() {
		this.appModal = {
			icon: 'object-group',
			title: 'Create new template',
			component: {
				theme: 'dark-theme',
				name: 'custom-content',
				templateRef: this.createAppTemplate
			}
		};
		this.overlayService.createModal(this.appModal);
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.timelines) {
			this.router.navigate(['library/interactivity', row.data.timelines[0]]);
		}
	}
}
